'use strict';

import { companyState } from "../../sessionState/companyState";
import * as moment from "moment";

const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;
const AVERAGE_DAYS_IN_A_YEAR = 365.25;
const MONTHS_IN_A_YEAR = 12;

export function newUTCDate(year: number, month: number, date: number) {
    return new Date(Date.UTC(year, month, date));
}

export function numberOfOverlappingMonths(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date) {
    const endDate = new Date(Math.min(firstEndDate.getTime(), secondEndDate.getTime()));
    const startDate = new Date(Math.max(firstStartDate.getTime(), secondStartDate.getTime()));

    return Math.max(0, Math.ceil(monthsBetween(startDate, endDate)));
}

function addMSToDate(date: Date, ms: number) {
    const newDate = new Date(date.getTime() + ms);
    // if (newDate == "Invalid Date") {
    // throw `Could not add time ${ms} to date: ${date}`;
    // }
    return newDate;
}
export function addYearsToTime(date: Date, numYears: number) {
    const newDate = addMSToDate(date, numYears * MILLISECONDS_IN_A_DAY * AVERAGE_DAYS_IN_A_YEAR);
    return newUTCDate(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate());
}

function safelyCompareDates(mathFunc: (n1: number, n2: number) => number) {
    return (oneDate: Date, twoDate: Date) => {
        try {
            const earlierInMS = mathFunc(oneDate.getTime(), twoDate.getTime());
            return new Date(earlierInMS);
        } catch (e) {
            return oneDate || twoDate;
        }
    };
}

export function formatMomentDate(maybeDate: Date) {
    return maybeDate ? moment.utc(maybeDate).format(companyState.momentDateFormat) : "";
}

export function earlierDate(oneDate: Date, twoDate: Date) {
    return safelyCompareDates(Math.min)(oneDate, twoDate);
}

export function laterDate(oneDate: Date, twoDate: Date) {
    return safelyCompareDates(Math.max)(oneDate, twoDate);
}

export function earlierMomentBetween(oneDate: moment.Moment, twoDate: moment.Moment) {
    return oneDate.isBefore(twoDate) ? oneDate : twoDate;
}

function momentsBetween(earlierDate: Date, laterDate: Date, units: 'years'|'months'|'days') {
    return moment.utc(laterDate).diff(moment.utc(earlierDate), units, true);
}

export function yearsBetween(earlierDate: Date, laterDate: Date) {
    return momentsBetween(earlierDate, laterDate, 'years');
}

export function monthsBetween(earlierDate: Date, laterDate: Date) {
    return momentsBetween(earlierDate, laterDate, 'months');
}

export function daysBetween(earlierDate: Date, laterDate: Date) {
    return momentsBetween(earlierDate, laterDate, 'days');
}

export function addMonthsMaintainDate(start: moment.Moment, months: number, startDay: number) {
    //This is a correction to the way momentjs adds months
    //It goes from Jan 31 to Feb 28 to March 28...
    let futureDate = start.clone().add(months, "months");
    const latestValidDate = earlierMomentBetween(
        futureDate.endOf('month'),
        futureDate.clone().set('date', startDay)
    ).date();
    return futureDate.set('date', latestValidDate);
}



// WEBPACK FOOTER //
// ./_src/services/constants/generic/calendarCalculator.ts